module.exports = __webpack_public_path__ + "media/images/version_merge/personal_data_protection-82f0a562a8182e7458e66acb5946f15e.png";